import { useEffect, useState } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import api from "../../../../services/api/api";
import { Box, Card, CardContent, Typography, Grid, CardMedia, Button, Pagination } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useTheme } from "@mui/material/styles";

const calcularDias = (dataPostagem) => {
  const dataAtual = new Date();
  const data = new Date(dataPostagem);
  const diferencaMs = dataAtual - data;
  return Math.floor(diferencaMs / (1000 * 60 * 60 * 24));
};

const SearchResults = () => {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search).get("q");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const itemsPerPage = 20;

  useEffect(() => {
    const fetchSearchResults = async () => {
      if (query) {
        try {
          setLoading(true);
          const encodedQuery = encodeURIComponent(query);

          const [publicacoesResponse, newsResponse] = await Promise.all([
            api.get(`/api/getAllPublications?q=${encodedQuery}`),
            api.get(`/api/getAllNews?q=${encodedQuery}`),
          ]);

          const publicacoes = publicacoesResponse.data.map((item) => ({
            id: item._id,
            name: item.name,
            file: item.file,
            category: "Publicação",
            publicationDate: item.publicationDate,
            isPublication: true,
          }));

          const news = newsResponse.data.map((item) => ({
            id: item._id,
            title: item.title,
            image: item.CapaImage,
            category: item.category,
            createdAt: item.createdAt,
            isPublication: false,
          }));

          setResults([...publicacoes, ...news]);
        } catch (error) {
          console.error("Erro ao buscar resultados:", error.message);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchSearchResults();
  }, [query]);

  const totalPages = Math.ceil(results.length / itemsPerPage);
  const paginatedResults = results.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  return (
    <Box sx={{ padding: "40px", width:{ xs: "95%%", md: "70%" } }}>
      <Typography variant="h4" sx={{ color: "black", marginBottom: "20px" }}>
        Resultados de Pesquisa para "{query}"
      </Typography>

      {loading ? (
        <Typography sx={{ color: "black" }}>Carregando...</Typography>
      ) : results.length > 0 ? (
        <>
          <Grid container spacing={2}>
            {paginatedResults.map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item.id}>
                <Card
                  sx={{ cursor: "pointer", display: "flex", flexDirection: "column", height: "100%" }}
                  onClick={() => (item.isPublication ? window.open(item.file, "_blank") : navigate(`/noticia/${item.id}`))}
                >
                  {item.isPublication ? (
                    <Box sx={{ textAlign: "center", padding: "10px", backgroundColor: theme.palette.primary.main, color: "white", borderRadius: "10px" }}>
                      <PictureAsPdfIcon sx={{ fontSize: "50px" }} />
                      <Typography sx={{ fontWeight: 700, textTransform: "uppercase" }}>{item.category}</Typography>
                    </Box>
                  ) : (
                    <CardMedia component="img" height="140" image={item.image} alt={item.title} />
                  )}
                  <CardContent>
                    <Typography sx={{ textTransform: "uppercase", fontWeight: 700 }}>
                      {item.isPublication ? item.name : item.title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {item.isPublication ? `Publicado em: ${new Date(item.publicationDate).toLocaleDateString("pt-BR")}` : `${calcularDias(item.createdAt)} dias atrás`}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
          <Box sx={{ display: "flex", justifyContent: "center", marginTop: 4 }}>
            <Pagination count={totalPages} page={page} onChange={handlePageChange} color="primary" />
          </Box>
        </>
      ) : (
        <Typography sx={{ color: "black" }}>Sem resultados para "{query}"</Typography>
      )}
    </Box>
  );
};

export default SearchResults;
